export const AVAILABLE_STATE = "available";
